<script lang="ts">
  import ChangeToAlert from './partials/ChangeToAlert.svelte';
  import LicenseTypeChangeAlert from './partials/LicenseTypeChangeAlert.svelte';
  import UpdatedAlert from './partials/UpdatedAlert.svelte';
  import { ListAlertType } from './ListAlertProps';
  import AddNewAlert from './partials/AddNewAlert.svelte';
  import type { DataListAlert } from '$provider/models/datalist/DataListAlert';
  import StateChangeAlert from './partials/StateChangeAlert.svelte';
  import BoardCertTypeChangeAlert from './partials/BoardCertTypeChangeAlert.svelte';
  import InsuranceCoverageTypeChangeAlert from './partials/InsuranceCoverageTypeChangeAlert.svelte';
  import EducationSchoolNameChangeAlert from './partials/EducationSchoolNameChangeAlert.svelte';
  import AddNewSectionAlert from './partials/AddNewSectionAlert.svelte';
  import ChangeToNewSection from './partials/ChangeToNewSection.svelte';
  import SpecialtyChangeAlert from './partials/SpecialtyChangeAlert.svelte';

  const MapComponentWithAlertType: ObjectType<any> = {
    [ListAlertType.Added]: AddNewAlert,
    [ListAlertType.Updated]: UpdatedAlert,
    [ListAlertType.ChangeTo]: ChangeToAlert,
    [ListAlertType.LicenseTypeChange]: LicenseTypeChangeAlert,
    [ListAlertType.StateChange]: StateChangeAlert,
    [ListAlertType.BoardCertTypeChange]: BoardCertTypeChangeAlert,
    [ListAlertType.InsuranceCoverageTypeChange]: InsuranceCoverageTypeChangeAlert,
    [ListAlertType.EducationSchoolNameChange]: EducationSchoolNameChangeAlert,
    [ListAlertType.AddNewSection]: AddNewSectionAlert,
    [ListAlertType.ChangeNewSection]: ChangeToNewSection,
    [ListAlertType.SpecialtyChange]: SpecialtyChangeAlert
  };

  interface Props {
    alert: DataListAlert;
    onevent?: (payload: any) => void;
  }

  let { alert, onevent }: Props = $props();

  let component = $derived(MapComponentWithAlertType[alert.type]);
</script>

{#if alert && component}
  {@const SvelteComponent = component}
  <SvelteComponent {alert} {onevent} />
{:else if !component}
  <div class="invalid">Invalid alert type</div>
{/if}
